import React from "react";

export default function Age({ onChange }) {
    const [years, setYears] = React.useState("");

    const handleYearChange = (event) => {
        const newYears = event.target.value.replace(/[^0-9]/g, "");
        setYears(newYears);
        onChange(newYears)
    };

    return (
        <div className="text-sm sm:text-base mb-2 cursor-default">
            <div
                className="text-sm sm:text-base mb-2 cursor-default"
                id="AgeLabel"
            >
                Votre âge
            </div>

            <div className="flex gap-8">
                <div className="flex items-center gap-2">
                    <input
                        type="text"
                        inputMode="numeric"
                        className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
                        onChange={handleYearChange}
                        value={years}
                        aria-labelledby="AgeLabel"
                        aria-describedby="AgeDescription"
                        role="spinbutton"
                        aria-valuenow={parseInt(years, 10) || undefined}
                    />
                    <div className="text-base sm:text-xl font-bold cursor-default">ans</div>
                </div>
            </div>
        </div>
    );
}
